"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoBoneProcessType = void 0;
var AutoBoneProcessType;
(function (AutoBoneProcessType) {
    AutoBoneProcessType[AutoBoneProcessType["NONE"] = 0] = "NONE";
    AutoBoneProcessType[AutoBoneProcessType["RECORD"] = 1] = "RECORD";
    AutoBoneProcessType[AutoBoneProcessType["SAVE"] = 2] = "SAVE";
    AutoBoneProcessType[AutoBoneProcessType["PROCESS"] = 3] = "PROCESS";
    /**
     * @deprecated
     * Use AutoBoneApplyRequest instead
     */
    AutoBoneProcessType[AutoBoneProcessType["APPLY"] = 4] = "APPLY";
})(AutoBoneProcessType = exports.AutoBoneProcessType || (exports.AutoBoneProcessType = {}));
